const workshopFeaturesZh = {
  // 抛光机（pol-001 ~ pol-010）
  product_pol_001_feature_1_title: '智能 LCD 数显与精准调速',
  product_pol_001_feature_1_desc: '配备高清 LCD 液晶显示屏，实时显示工作转速，支持 2000-4500/min 多档位精准调速，让您在不同材质与抛光阶段都能拥有最直观的掌控感。',
  product_pol_001_feature_2_title: '恒功率与软启动技术',
  product_pol_001_feature_2_desc: '内置智能芯片提供恒功率补偿，确保在高负荷压下时转速依然稳定不掉速；配合软启动功能，有效防止抛光蜡迸溅，确保作业表面完美细腻。',
  product_pol_001_feature_3_title: '8mm 偏心振幅设计',
  product_pol_001_feature_3_desc: '采用 8mm (0.32") 偏心振幅设计，这种双作用随机轨道运动能有效避免产生炫光纹或烧伤漆面，极大提升抛光效率与安全性。',
  product_pol_001_feature_4_title: '专业级 150mm 大直径磨盘',
  product_pol_001_feature_4_desc: '适配 Ø150mm (5.9") 抛光盘，单次覆盖面积更大，特别适合车漆、大理石及家居表面的大面积快速修复与镜面处理。',
  product_pol_001_feature_5_title: '人体工学长手柄结构',
  product_pol_001_feature_5_desc: '1.6kg 的平衡机身配合修长的握持部位，不仅单手操控更灵活，且能有效减轻长时间作业的疲劳感，带给您工业级的舒适操作体验。',

  product_pol_002_feature_1_title: '150 mm 旋转式抛光机',
  product_pol_002_feature_1_desc: '150 mm 旋转式抛光机在专业车身修复收尾中提供高速漆面切削和研磨膏涂布。',
  product_pol_002_feature_2_title: '600–3200 RPM 旋转速度',
  product_pol_002_feature_2_desc: '600 到 3200 RPM 变速覆盖从研磨膏切削到最终光泽收尾的完整范围。',
  product_pol_002_feature_3_title: '750W 切削动力电机',
  product_pol_002_feature_3_desc: '750W 电机提供在划伤或氧化漆面上进行激进研磨膏切削所需的高扭矩。',
  product_pol_002_feature_4_title: '2.3 kg 稳定旋转机身',
  product_pol_002_feature_4_desc: '2.3 kg 机身重量在旋转切削过程中帮助维持对面板表面的一致研磨膏压力。',
  product_pol_002_feature_5_title: '5.0 N·m 切削扭矩',
  product_pol_002_feature_5_desc: '5.0 N·m 扭矩输出防止旋转机在研磨膏阻力下减速，实现均匀漆面切削。',

  product_pol_003_feature_1_title: '125 mm 紧凑轨道抛光机',
  product_pol_003_feature_1_desc: '125 mm 轨道抛光盘抛光门框、保险杠端部和 A 柱等较大抛光盘无法触达的紧凑区域。',
  product_pol_003_feature_2_title: '2500–7800 OPM 精细抛光速度',
  product_pol_003_feature_2_desc: '高达 7800 OPM 的最高速度提供完全去除旋痕的最终抛光所需的速度。',
  product_pol_003_feature_3_title: '350W 紧凑抛光电机',
  product_pol_003_feature_3_desc: '350W 紧凑 AC 电机在紧凑面板截面上高效运行 125 mm 小抛光盘，不过热。',
  product_pol_003_feature_4_title: '1.6 kg 单手抛光',
  product_pol_003_feature_4_desc: '1.6 kg 足够轻便，可在小面板和紧凑细节区域进行单手抛光。',
  product_pol_003_feature_5_title: '2.5 N·m 细节扭矩',
  product_pol_003_feature_5_desc: '2.5 N·m 扭矩针对小区域精细抛光优化，不会烧伤精细清漆层。',

  product_pol_004_feature_1_title: '200 mm 长行程抛光机',
  product_pol_004_feature_1_desc: '200 mm 大抛光盘覆盖引擎盖、车顶和车门等平整车身面板，每次作业通过次数大幅减少。',
  product_pol_004_feature_2_title: '2000–6200 OPM 宽速范围',
  product_pol_004_feature_2_desc: '2000–6200 OPM 覆盖低速轻度打蜡到高速激进研磨膏施工的所有场景。',
  product_pol_004_feature_3_title: '650W 大盘电机',
  product_pol_004_feature_3_desc: '650W AC 电机在长时间平面板抛光作业中持续承受大型 200 mm 抛光盘的较高负载。',
  product_pol_004_feature_4_title: '2.5 kg 专业机身重量',
  product_pol_004_feature_4_desc: '2.5 kg 机身重量为水平表面上的大型 200 mm 抛光盘提供正确的下压力。',
  product_pol_004_feature_5_title: '4.5 N·m 高盘扭矩',
  product_pol_004_feature_5_desc: '4.5 N·m 扭矩防止大型 200 mm 抛光盘在研磨膏阻力下减速。',

  product_pol_005_feature_1_title: '180 mm 家具抛光机',
  product_pol_005_feature_1_desc: '180 mm 轨道抛光机用于家具打蜡、清漆收尾和木质表面磨光至高光泽。',
  product_pol_005_feature_2_title: '1500–6800 OPM 家具速度',
  product_pol_005_feature_2_desc: '低起始速度 1500 OPM，防止家具表面初次涂蜡时产生木清漆条纹。',
  product_pol_005_feature_3_title: '500W 木质抛光电机',
  product_pol_005_feature_3_desc: '500W AC 电机为家具抛光提供正确的功率平衡，不过热精细木质漆面。',
  product_pol_005_feature_4_title: '2.1 kg 均衡家具工具',
  product_pol_005_feature_4_desc: '2.1 kg 均衡重量在家具面板和弯曲木质表面上保持均匀接触。',
  product_pol_005_feature_5_title: '24 个月质保',
  product_pol_005_feature_5_desc: '2 年全面质保保护专业家具收尾工坊免受意外工具故障影响。',

  product_pol_006_feature_1_title: '150 mm 中型收尾抛光机',
  product_pol_006_feature_1_desc: '150 mm 抛光盘在紧凑细节抛光机和大型平面板机器之间架起桥梁，多功能收尾。',
  product_pol_006_feature_2_title: '1500–6500 OPM 精准控制',
  product_pol_006_feature_2_desc: '1500–6500 OPM 顺滑线性速度控制，允许在切削、抛光和收尾阶段之间平滑过渡。',
  product_pol_006_feature_3_title: '600W 中档电机',
  product_pol_006_feature_3_desc: '600W 电机以一致输出处理研磨膏、抛光剂和蜡覆盖 150 mm 抛光盘。',
  product_pol_006_feature_4_title: '2.2 kg 中等均衡',
  product_pol_006_feature_4_desc: '2.2 kg 中等重量使这款抛光机在门板和侧翼板等竖直面板施工中舒适使用。',
  product_pol_006_feature_5_title: '4.0 N·m 中等扭矩输出',
  product_pol_006_feature_5_desc: '4.0 N·m 扭矩以同等效果处理中等研磨膏切削和最终收尾。',

  product_pol_007_feature_1_title: '125 mm 无绳轨道抛光机',
  product_pol_007_feature_1_desc: '20V 无绳 125 mm 抛光机，工坊任何位置或户外活动均可作业，无需电源插座。',
  product_pol_007_feature_2_title: '2500–7800 OPM 无绳速度',
  product_pol_007_feature_2_desc: '无绳可用全速 2500–7800 OPM，尽管采用电池形式，抛光性能无任何妥协。',
  product_pol_007_feature_3_title: '20V 电池平台自由',
  product_pol_007_feature_3_desc: '兼容 20V 电池平台，与其他工具共享电池，灵活的工坊布置。',
  product_pol_007_feature_4_title: '1.8 kg 无绳便利',
  product_pol_007_feature_4_desc: '包含电池 1.8 kg，比大多数有绳抛光机更轻，可在细节区域进行单手操作。',
  product_pol_007_feature_5_title: '350W 高效无绳电机',
  product_pol_007_feature_5_desc: '350W 无刷电机最大化电池效率，每次充电比有刷替代品提供更多抛光时间。',

  product_pol_008_feature_1_title: '气动 180 mm 气动抛光机',
  product_pol_008_feature_1_desc: '气动 180 mm 抛光机是最轻的 1.9 kg，非常适合有压缩空气的专业车身修复工坊。',
  product_pol_008_feature_2_title: '0.63 MPa 气动操作',
  product_pol_008_feature_2_desc: '由标准 0.63 MPa 气泵气源驱动，直接连接压缩机管路实现不间断操作。',
  product_pol_008_feature_3_title: '75 dB 最静音抛光机',
  product_pol_008_feature_3_desc: '≤75 dB 是系列中最安静的，气动操作本质上比电动电机噪音更低。',
  product_pol_008_feature_4_title: '1.9 kg 最轻专业抛光机',
  product_pol_008_feature_4_desc: '1.9 kg 是抛光机系列中最轻的机身，减少高产量车身修复生产中的手臂疲劳。',
  product_pol_008_feature_5_title: '无需电池或电源线',
  product_pol_008_feature_5_desc: '气动设计消除电池和电源线，插上气管即可连续抛光。',

  product_pol_009_feature_1_title: '150 mm 细节店抛光机',
  product_pol_009_feature_1_desc: '150 mm 抛光机针对专业细节店优化，单一工具处理从研磨膏到最终打蜡的所有阶段。',
  product_pol_009_feature_2_title: '2500–6800 OPM 工坊速度',
  product_pol_009_feature_2_desc: '2500–6800 OPM 覆盖从切削研磨膏到收尾打蜡的完整专业美容流程。',
  product_pol_009_feature_3_title: '500W 可靠工坊电机',
  product_pol_009_feature_3_desc: '500W 电机每天多辆车的美容专业人员提供可靠一致的性能。',
  product_pol_009_feature_4_title: '2.0 kg 高效工坊重量',
  product_pol_009_feature_4_desc: '2.0 kg 适合每天处理多辆车的美容师，减少累积手臂疲劳。',
  product_pol_009_feature_5_title: '3.5 N·m 均衡扭矩',
  product_pol_009_feature_5_desc: '3.5 N·m 均衡扭矩输出在研磨膏、抛光剂和保护涂层应用上同样有效。',

  product_pol_010_feature_1_title: '180 mm 专业工作室抛光机',
  product_pol_010_feature_1_desc: '180 mm 专业工作室抛光机，用于高端美容、赛车展示准备和豪华车辆收尾。',
  product_pol_010_feature_2_title: '2500–6800 OPM 高端速度',
  product_pol_010_feature_2_desc: '2500–6800 OPM 高端范围处理专业级漆面修正和保护施工的所有阶段。',
  product_pol_010_feature_3_title: '500W 持续高端动力',
  product_pol_010_feature_3_desc: '500W AC 电机维持一致的抛光盘速度，在高价值车辆上实现均匀的表面收尾质量。',
  product_pol_010_feature_4_title: '2.2 kg 专业机身',
  product_pol_010_feature_4_desc: '2.2 kg 精心均衡的专业机身确保在弯曲面板表面的一致抛光盘压力。',
  product_pol_010_feature_5_title: '24 个月工坊质保',
  product_pol_010_feature_5_desc: '2 年质保支持每天密集使用工具的高产量专业美容作业。',

  // 砂磨机（san-001 ~ san-010）
  product_san_001_feature_1_title: '125 mm 随机轨道砂磨机',
  product_san_001_feature_1_desc: '125 mm 随机轨道运动在木材、金属和腻子表面产生无旋痕的磨砂效果。',
  product_san_001_feature_2_title: '4000–12000 OPM 打磨速度',
  product_san_001_feature_2_desc: '4000–12000 OPM 变速覆盖从激进材料去除到精细收尾打磨的所有场景。',
  product_san_001_feature_3_title: '350W 高效打磨电机',
  product_san_001_feature_3_desc: '350W 电机以一致的材料去除率穿透车身腻子、漆层和木质表面。',
  product_san_001_feature_4_title: '1.4 kg 轻量砂磨机',
  product_san_001_feature_4_desc: '1.4 kg 足够轻便，适合头顶打磨和长时间连续使用，不感疲劳。',
  product_san_001_feature_5_title: '集尘接口',
  product_san_001_feature_5_desc: '集成集尘接口连接工坊吸尘器，实现干净低粉尘的打磨作业环境。',

  product_san_002_feature_1_title: '150 mm 大面积轨道砂磨机',
  product_san_002_feature_1_desc: '150 mm 打磨盘每次通过覆盖面积比 125 mm 砂磨机大 44%，大面积施工效率显著提升。',
  product_san_002_feature_2_title: '4000–12000 OPM 变速范围',
  product_san_002_feature_2_desc: '150 mm 盘上 4000–12000 OPM 兼顾激进漆面剥离和超精细收尾打磨。',
  product_san_002_feature_3_title: '380W 大磨片电机',
  product_san_002_feature_3_desc: '380W 电机在较大 150 mm 打磨盘的增加负载下保持速度，结果一致。',
  product_san_002_feature_4_title: '1.6 kg 大盘均衡',
  product_san_002_feature_4_desc: '1.6 kg 均衡重量在较大 150 mm 打磨盘表面提供均匀的打磨压力。',
  product_san_002_feature_5_title: '76 dB 低噪音运行',
  product_san_002_feature_5_desc: '≤76 dB 使这款较大的轨道砂磨机成为工坊使用中同类产品中最安静之一。',

  product_san_003_feature_1_title: '93 mm 三角形细节砂磨机',
  product_san_003_feature_1_desc: '三角形 93 mm 打磨盘触达圆形砂磨机无法进入的角落、橱柜接缝内部和细节区域。',
  product_san_003_feature_2_title: '8000–20000 OPM 高速细节',
  product_san_003_feature_2_desc: '高达 20000 OPM 的最高速度在紧凑角落提供精准细节打磨，不卡顿。',
  product_san_003_feature_3_title: '250W 紧凑角落电机',
  product_san_003_feature_3_desc: '250W 电机为小三角形打磨盘提供动力，快速整洁打磨接缝、角落和成型表面。',
  product_san_003_feature_4_title: '1.1 kg 超轻细节工具',
  product_san_003_feature_4_desc: '仅 1.1 kg，这是最轻的砂磨机，非常适合全天家具和线条精细细节打磨。',
  product_san_003_feature_5_title: '三点打磨几何',
  product_san_003_feature_5_desc: '三角形几何单次通过即可触达内部角落和造型线条所有三个侧面。',

  product_san_004_feature_1_title: '200×75 mm 砂带机',
  product_san_004_feature_1_desc: '200×75 mm 砂带砂带机材料去除比轨道砂磨机更快，适用于粗糙木质表面的整平。',
  product_san_004_feature_2_title: '0–3 m/s 变速砂带',
  product_san_004_feature_2_desc: '0 到 3 m/s 变速砂带，材料去除率从轻柔到激进自由调节。',
  product_san_004_feature_3_title: '500W 激进去料电机',
  product_san_004_feature_3_desc: '500W 电机处理粗锯木材、厚漆和硬木地板的激进材料去除。',
  product_san_004_feature_4_title: '2.8 kg 砂带机稳定性',
  product_san_004_feature_4_desc: '2.8 kg 机身重量帮助维持一致的砂带接触压力，实现平整均匀的材料去除。',
  product_san_004_feature_5_title: '快换砂带系统',
  product_san_004_feature_5_desc: '无需工具的砂带更换系统几秒内即可更换打磨砂带，无需扳手或手动调节追踪。',

  product_san_005_feature_1_title: '125 mm 防旋痕砂磨机',
  product_san_005_feature_1_desc: '防旋痕轨道机构在硬木家具和涂漆面板上产生更整洁、更精细的表面。',
  product_san_005_feature_2_title: '4000–12000 OPM 收尾质量',
  product_san_005_feature_2_desc: '4000–12000 OPM 范围在同一工具上实现快速材料去除和镜面般光滑收尾。',
  product_san_005_feature_3_title: '350W 可靠收尾电机',
  product_san_005_feature_3_desc: '350W 电机在手工打磨作业的变化压力下保持一致的打磨盘速度。',
  product_san_005_feature_4_title: '1.4 kg 家具收尾重量',
  product_san_005_feature_4_desc: '轻量 1.4 kg 非常适合长时间家具收尾作业，手臂疲劳会降低打磨质量。',
  product_san_005_feature_5_title: '魔术贴快换系统',
  product_san_005_feature_5_desc: '魔术贴附着系统允许无需工具快速更换粒度，几秒内从 80 目换至 400 目。',

  product_san_006_feature_1_title: '150 mm 专业收尾砂磨机',
  product_san_006_feature_1_desc: '150 mm 专业砂磨机提供家具制造商要求的大面积覆盖和表面质量。',
  product_san_006_feature_2_title: '4000–12000 OPM 专业收尾速度',
  product_san_006_feature_2_desc: '全变速 12000 OPM 最高速度产生专业制造商要求的精细均匀收尾表面质量。',
  product_san_006_feature_3_title: '380W 专业打磨电机',
  product_san_006_feature_3_desc: '380W AC 电机在厚木质收尾去除和精细木纹准备过程中持续 150 mm 打磨盘速度。',
  product_san_006_feature_4_title: '1.6 kg 专业均衡',
  product_san_006_feature_4_desc: '1.6 kg 专业重量提供精细家具收尾施工所需的受控手工压力。',
  product_san_006_feature_5_title: '76 dB 工坊友好噪音',
  product_san_006_feature_5_desc: '≤76 dB 使这款 150 mm 砂磨机适合有噪音管理要求的工坊使用。',

  product_san_007_feature_1_title: '125 mm 20V 无绳砂磨机',
  product_san_007_feature_1_desc: '无绳 20V 轨道砂磨机，现场木工、翻新和涂装准备作业，无需电源线。',
  product_san_007_feature_2_title: '4000–12000 OPM 无绳速度',
  product_san_007_feature_2_desc: '电池动力可用全速 12000 OPM，在没有市电时作业性能无妥协。',
  product_san_007_feature_3_title: '20V 电池平台',
  product_san_007_feature_3_desc: '20V 电池兼容性允许与其他无绳工具共享电源，一块电池多种工具。',
  product_san_007_feature_4_title: '1.5 kg 无绳便携性',
  product_san_007_feature_4_desc: '1.5 kg 含电池，在工地任何位置舒适便携打磨，无需延长线。',
  product_san_007_feature_5_title: '350W 高效无刷电机',
  product_san_007_feature_5_desc: '无刷 350W 电机延长电池续航，在长时间无绳打磨中产生更少热量。',

  product_san_008_feature_1_title: '100 mm 气动细节砂磨机',
  product_san_008_feature_1_desc: '100 mm 气动砂磨机是最轻的 0.9 kg，非常适合持续气源供应的生产线细节打磨。',
  product_san_008_feature_2_title: '0.63 MPa 气动操作',
  product_san_008_feature_2_desc: '由压缩空气驱动，在持续气源供应的生产线上提供不间断打磨操作。',
  product_san_008_feature_3_title: '0.9 kg 超轻气动机身',
  product_san_008_feature_3_desc: '0.9 kg 是最轻的砂磨机，减少高日产量生产线操作员的疲劳。',
  product_san_008_feature_4_title: '70 dB 静音气动打磨',
  product_san_008_feature_4_desc: '≤70 dB 是系列中最安静的，气动打磨显著降低工坊噪音水平。',
  product_san_008_feature_5_title: '无需电池或电源线',
  product_san_008_feature_5_desc: '气动设计消除所有电池和电源线管理，实现最整洁高效的工作流程。',

  product_san_009_feature_1_title: '225 mm 长触达墙面砂磨机',
  product_san_009_feature_1_desc: '225 mm 大型打磨盘从地板水平打磨灰泥、石膏板和天花板表面，无需脚手架和梯子。',
  product_san_009_feature_2_title: '200–650 RPM 墙面打磨速度',
  product_san_009_feature_2_desc: '缓慢 200–650 RPM 范围防止刮伤石膏板腻子，同时提供有效的表面准备。',
  product_san_009_feature_3_title: '750W 墙面打磨电机',
  product_san_009_feature_3_desc: '750W 电机驱动 225 mm 打磨盘穿过灰泥和石膏板，即使在纹理墙面上也不卡顿。',
  product_san_009_feature_4_title: '3.2 kg 长触达稳定性',
  product_san_009_feature_4_desc: '3.2 kg 机身重量配合长把手提供一致石膏板表面准备所需的稳定性。',
  product_san_009_feature_5_title: '伸缩把手系统',
  product_san_009_feature_5_desc: '延伸把手无需梯子即可触达从地板到天花板，石膏板承包商的最高生产效率。',

  product_san_010_feature_1_title: '125 mm 经济工坊砂磨机',
  product_san_010_feature_1_desc: '可靠的 125 mm 轨道砂磨机，日常工坊使用，处理漆面去除、木材准备和最终收尾。',
  product_san_010_feature_2_title: '4000–12000 OPM 工坊范围',
  product_san_010_feature_2_desc: '全速 12000 OPM 变速范围覆盖从剥离到收尾的所有常见工坊打磨任务。',
  product_san_010_feature_3_title: '70 dB 超低噪音',
  product_san_010_feature_3_desc: '≤70 dB 是 125 mm 砂磨机类别中最低噪音，非常适合靠近居住区的家庭工坊。',
  product_san_010_feature_4_title: '1.4 kg 经济主力',
  product_san_010_feature_4_desc: '1.4 kg 轻量机身为需要实用每日砂磨机的业余爱好者和 DIY 用户提供出色性价比。',
  product_san_010_feature_5_title: '350W 可靠经济电机',
  product_san_010_feature_5_desc: '350W 电机为日常 DIY 和轻型专业工坊任务提供一致的性能。',

  // 热熔胶枪（glue-001 ~ glue-010）
  product_glue_001_feature_1_title: '极速预热与启动',
  product_glue_001_feature_1_desc: '采用先进的 MCH 陶瓷发热技术，实现 2 秒闪速启动和 15 秒极速预热，大幅减少作业等待时间。',
  product_glue_001_feature_2_title: '人性化智能安全保护',
  product_glue_001_feature_2_desc: '内置 5 分钟自动关机功能，有效防止能源浪费并降低安全隐患；同时配备可视化余料窗口，随时掌握胶棒消耗情况。',
  product_glue_001_feature_3_title: '精准顺滑的操控体验 ',
  product_glue_001_feature_3_desc: '采用板机联动送料设计与 1.3mm 精细出胶孔，确保出胶均匀稳定，轻松应对各种细腻的粘合任务。',
  product_glue_001_feature_4_title: '便捷的 USB-C 快充',
  product_glue_001_feature_4_desc: '通用的 USB Type-C 充电接口设计，让您随时随地都能通过移动电源或适配器为设备补充动力。',
  product_glue_001_feature_5_title: '极致轻盈的人体工学',
  product_glue_001_feature_5_desc: '整机仅重 0.25kg，极致轻巧的机身配合内置 LED 工作灯，即便在狭小或昏暗空间作业也毫无压力。',

  product_glue_002_feature_1_title: '工业级 MCH 陶瓷加热技术',
  product_glue_002_feature_1_desc: '搭载高性能 MCH 发热元件，支持 2 秒闪速启动与 15 秒极速预热，确保在快节奏作业中提供恒温稳定的出胶表现。',
  product_glue_002_feature_2_title: '卓越的续航与作业能力',
  product_glue_002_feature_2_desc: '配合 12V 2.0Ah 电池组，一次充电即可使用 40 根胶棒，作业容量较 4V 型号翻倍，满足长时间大负荷工作需求。',
  product_glue_002_feature_3_title: '精准控胶与可视化设计',
  product_glue_002_feature_3_desc: '具备 1.3mm 精细出胶孔与板机联动送料系统，结合侧边可视化余料窗口，让操作精准掌控并能随时监测胶棒余量。',
  product_glue_002_feature_4_title: '全方位的智能安全保障',
  product_glue_002_feature_4_desc: '内置 5 分钟自动关机智能系统，防止意外烫伤与能源浪费；配备 LED 工作灯，确保在光线不足的复杂环境下也能安全作业。',
  product_glue_002_feature_5_title: '稳固耐用的工业级结构',
  product_glue_002_feature_5_desc: '0.45kg 的机身重心分布均匀，采用 12V 插拔式电池底座设计，不仅作业更平稳，还可作为支架随时平稳放置于台面。',

  product_glue_003_feature_1_title: '•	全自动智能进料系统',
  product_glue_003_feature_1_desc: '创新搭载全自动进料与装载系统，彻底告别手动按压，实现连续、精准且均匀的自动出胶体验。',
  product_glue_003_feature_2_title: '•	高效工业级加热效能',
  product_glue_003_feature_2_desc: '采用 MCH 陶瓷加热技术，仅需 110 秒预热，出胶量高达 13g/min，配合 3mm 大孔径出胶口，专为大面积重型粘合设计。',
  product_glue_003_feature_3_title: '•	巅峰级续航与作业量',
  product_glue_003_feature_3_desc: '适配 20V 2.0Ah 强劲动力电池，单次充电可消耗 15 根 ∅11 x 200mm 工业级长胶棒，满足严苛工况下的超长作业需求。',
  product_glue_003_feature_4_title: '•	多重智能监控防护',
  product_glue_003_feature_4_desc: '具备 5 分钟自动断电保护与缺料报警指示灯，结合内置 LED 工作灯，确保在任何环境下作业都安全高效且尽在掌握。',
  product_glue_003_feature_5_title: '•	专业级稳固结构设计',
  product_glue_003_feature_5_desc: '0.36kg 的轻量化设计结合稳固的 20V 电池座支撑，不仅抓握舒适，更能稳固放置于作业台，无惧胶液滴漏风险。',

  product_glue_004_feature_1_title: '120W 双温胶枪',
  product_glue_004_feature_1_desc: '120W 胶枪可选高低温模式，为热敏和标准材料的粘接提供灵活性。',
  product_glue_004_feature_2_title: '160–230°C 宽温度范围',
  product_glue_004_feature_2_desc: '系列中最宽的温度范围，从低温泡沫施工到高温结构木材和金属粘接。',
  product_glue_004_feature_3_title: '14 g/分钟最快出胶',
  product_glue_004_feature_3_desc: '14 g/分钟是系列中最高的出胶量，非常适合高速生产粘接和组装施工。',
  product_glue_004_feature_4_title: '120W 最大功率',
  product_glue_004_feature_4_desc: '120W 是最高可用功率，在持续高输出使用时提供快速的温度恢复。',
  product_glue_004_feature_5_title: '双模温度切换',
  product_glue_004_feature_5_desc: '可切换温度模式，在 160°C 手工模式和 230°C 工业模式之间切换，无需更换工具。',

  product_glue_005_feature_1_title: '80W 20V 无绳胶枪',
  product_glue_005_feature_1_desc: '20V 电池供电无绳胶枪，手工艺品制作、户外使用和工地粘接提供完全自由。',
  product_glue_005_feature_2_title: '20V 无绳电池平台',
  product_glue_005_feature_2_desc: '20V 电池兼容性与其他无绳工具共享电源，无需单独充电器或电池投入。',
  product_glue_005_feature_3_title: '180–210°C 无绳温度',
  product_glue_005_feature_3_desc: '电池动力维持最佳 180–210°C 工作温度，无需与 AC 型号的性能妥协。',
  product_glue_005_feature_4_title: '8 g/分钟无绳出胶率',
  product_glue_005_feature_4_desc: '8 g/分钟出胶量与 AC 供电型号匹配，完全由电池驱动。',
  product_glue_005_feature_5_title: '无电源线限制',
  product_glue_005_feature_5_desc: '无绳设计允许在任何位置、任何表面及没有电源插座的场所进行粘接。',

  product_glue_006_feature_1_title: '100W 纤薄机身胶枪',
  product_glue_006_feature_1_desc: '100W 纤薄枪管设计进入标准尺寸胶枪无法触达的狭窄缝隙和精密涂胶位置。',
  product_glue_006_feature_2_title: '190–220°C 受控热熔',
  product_glue_006_feature_2_desc: '190–220°C 的窄工作范围产生一致的胶液粘度，可预测的涂胶线控制。',
  product_glue_006_feature_3_title: '6 g/分钟受控流量',
  product_glue_006_feature_3_desc: '6 g/分钟受控流量，精密施工中防止过量涂胶，细节粘接质量优先于速度。',
  product_glue_006_feature_4_title: '282 mm 纤薄枪管长度',
  product_glue_006_feature_4_desc: '282 mm 纤薄机身触达紧凑橱柜角落和狭窄组装间隙，实现定向精准涂胶。',
  product_glue_006_feature_5_title: '43 dB 近乎无声操作',
  product_glue_006_feature_5_desc: '≤43 dB 是系列中最安静的，工作室和课堂环境实际上静默操作。',

  product_glue_007_feature_1_title: '150W 工业立式胶枪',
  product_glue_007_feature_1_desc: '150W 高功率胶枪带水平支架，适用于需要持续大量粘合剂涂布的生产环境。',
  product_glue_007_feature_2_title: '200–240°C 工业温度',
  product_glue_007_feature_2_desc: '200–240°C 高温范围能够粘接尼龙、聚碳酸酯和金属等坚韧工业材料。',
  product_glue_007_feature_3_title: '25 g/分钟最大出胶率',
  product_glue_007_feature_3_desc: '25 g/分钟是系列中最高输出，是标准速度的三倍，高速生产组装专用。',
  product_glue_007_feature_4_title: '150W 连续生产动力',
  product_glue_007_feature_4_desc: '150W 最大功率热量恢复足够快，在持续生产使用中维持 25 g/分钟输出。',
  product_glue_007_feature_5_title: '内置水平休息支架',
  product_glue_007_feature_5_desc: '集成支架在涂胶间隙安全放置胶枪，防止表面烧伤和枪嘴接触事故。',

  product_glue_008_feature_1_title: '80W 低滴漏专业胶枪',
  product_glue_008_feature_1_desc: '80W 防滴漏嘴头设计，防止涂胶间隙多余胶液滴漏，工件更整洁。',
  product_glue_008_feature_2_title: '170–210°C 防滴温度',
  product_glue_008_feature_2_desc: '优化 170–210°C 范围将胶液保持在最佳粘度，最大限度减少喷嘴滴漏。',
  product_glue_008_feature_3_title: '防滴嘴头设计',
  product_glue_008_feature_3_desc: '精密防滴嘴头阀门在扳机释放时立即停止胶液流动，防止工件污染。',
  product_glue_008_feature_4_title: '8 g/分钟洁净涂胶流量',
  product_glue_008_feature_4_desc: '8 g/分钟流量配合防滴嘴头，提供最整洁最精密的胶液涂布。',
  product_glue_008_feature_5_title: '0.4 kg 轻量防滴工具',
  product_glue_008_feature_5_desc: '0.4 kg 轻量机身使这款低滴漏胶枪在手工艺品和精细组装应用中舒适使用。',

  product_glue_009_feature_1_title: '100W 人体工学舒适胶枪',
  product_glue_009_feature_1_desc: '100W 胶枪配人体工学软握把，专为长时间手工艺品制作、课堂和工坊使用设计。',
  product_glue_009_feature_2_title: '185–225°C 延伸温度',
  product_glue_009_feature_2_desc: '185–225°C 覆盖比标准型号更广的范围，兼容更多种类的胶棒配方。',
  product_glue_009_feature_3_title: '人体工学软握把',
  product_glue_009_feature_3_desc: '轮廓软握把，减少长时间手工艺作业和教学使用时的手部疲劳。',
  product_glue_009_feature_4_title: '10 g/分钟稳定出胶',
  product_glue_009_feature_4_desc: '10 g/分钟出胶量平衡速度和控制，够快适合生产，够精细适合手工艺施工。',
  product_glue_009_feature_5_title: '0.5 kg 标准舒适重量',
  product_glue_009_feature_5_desc: '0.5 kg 提供稳定涂胶的正确握持重量，长时间作业也不感不适。',

  product_glue_010_feature_1_title: '80W 经典标准胶枪',
  product_glue_010_feature_1_desc: '80W 可靠的标准胶枪，适用于 DIY 维修、家庭手工艺品和各种常见粘接需求的轻型组装。',
  product_glue_010_feature_2_title: '180–210°C 通用温度',
  product_glue_010_feature_2_desc: '180–210°C 通用范围兼容所有标准 11 mm 胶棒，材料兼容性最广。',
  product_glue_010_feature_3_title: '320 mm 延伸枪管设计',
  product_glue_010_feature_3_desc: '320 mm 延伸枪管改善在货架背面和深层组装家具内部粘接时的可达性。',
  product_glue_010_feature_4_title: '8 g/分钟可靠出胶',
  product_glue_010_feature_4_desc: '8 g/分钟可靠出胶，处理从布料修复到家居装饰和手工艺品制作的日常粘接任务。',
  product_glue_010_feature_5_title: '0.4 kg 日常手工重量',
  product_glue_010_feature_5_desc: '0.4 kg 使这款胶枪轻便舒适，适合自发性家庭手工艺项目和快速维修任务。',

  // ===== 木工工具配件翻译 (ws_acc_* 系列) =====

  // 抛光机 pol-001 配件
  ws_acc_pol001_foam_pads_name: '泡沫抛光盘套装',
ws_acc_pol001_foam_pads_desc: '180mm三件套粗/中/细泡沫抛光盘，适用于DA双动作抛光机',
ws_acc_pol001_compound_name: '汽车研磨膏套装',
ws_acc_pol001_compound_desc: '重度/中度/轻度三阶段漆面修复研磨膏套装',
ws_acc_pol001_backing_plate_name: '魔术贴托盘',
ws_acc_pol001_backing_plate_desc: '180mm魔术贴平衡托盘，快速更换抛光盘',
ws_acc_pol001_applicators_name: '泡沫涂蜡盘',
ws_acc_pol001_applicators_desc: '圆形柔软泡沫涂蜡盘套装，手工涂抹蜡和保护膜',
ws_acc_pol001_quick_detailer_name: '快速清洁剂',
ws_acc_pol001_quick_detailer_desc: '500ml漆面快速清洁护理喷雾，维持光洁状态',
ws_acc_pol001_microfiber_name: '超细纤维毛巾套装',
ws_acc_pol001_microfiber_desc: '5件超柔380g/㎡绒毛超细纤维毛巾，适合打蜡和清洁',
ws_acc_pol001_gloves_name: '防滑工作手套',
ws_acc_pol001_gloves_desc: '橡胶掌面防滑半指手套，适合抛光作业',
ws_acc_pol001_bag_name: '工具收纳包',
ws_acc_pol001_bag_desc: 'EVA硬壳内衬工具收纳包，整齐存放抛光机及配件',

// pol-002 配件
ws_acc_pol002_wool_pad_name: '羊毛切割盘',
ws_acc_pol002_wool_pad_desc: '150mm旋转抛光机专用羊毛切割盘，重度漆面修复',
ws_acc_pol002_compound_name: '重度切割研磨膏',
ws_acc_pol002_compound_desc: '500ml重度切割研磨膏，快速去除深划痕和氧化层',
ws_acc_pol002_backing_plate_name: '托盘',
ws_acc_pol002_backing_plate_desc: '150mm螺纹魔术贴托盘，适用于旋转式抛光机',
ws_acc_pol002_compound_remover_name: '研磨膏清除剂',
ws_acc_pol002_compound_remover_desc: '200ml研磨膏残留清除喷雾，汽车精细打磨必备',
ws_acc_pol002_wrench_name: '托盘拆装扳手',
ws_acc_pol002_wrench_desc: '托盘专用拆装扳手，安全拆卸和安装托盘',
ws_acc_pol002_microfiber_name: '专业打磨毛巾',
ws_acc_pol002_microfiber_desc: '专业精细打磨超细纤维毛巾，无边360克重',
ws_acc_pol002_gloves_name: '机械工作手套',
ws_acc_pol002_gloves_desc: '橡胶掌面耐磨机械手套，旋转式抛光机专用',
ws_acc_pol002_bag_name: '帆布工具包',
ws_acc_pol002_bag_desc: '拉链帆布工具包，存放托盘、手套和打磨配件',

// pol-003 配件
ws_acc_pol003_mini_pads_name: '迷你抛光盘套装',
ws_acc_pol003_mini_pads_desc: '125mm五件套各目数泡沫抛光盘，适用于迷你抛光机',
ws_acc_pol003_swirl_remover_name: '旋痕去除剂',
ws_acc_pol003_swirl_remover_desc: '250ml细粒度精抛旋痕去除剂，恢复漆面镜面光泽',
ws_acc_pol003_backing_plate_name: '迷你托盘',
ws_acc_pol003_backing_plate_desc: '125mm平衡魔术贴迷你托盘，适用于紧凑型抛光机',
ws_acc_pol003_paint_cleaner_name: '漆面清洁剂',
ws_acc_pol003_paint_cleaner_desc: '200ml漆面预抛光清洁剂，抛光前表面预处理',
ws_acc_pol003_detail_applicators_name: '细节涂蜡盘',
ws_acc_pol003_detail_applicators_desc: '6件弯曲泡沫细节涂蜡盘套装，适用于狭窄区域精细作业',
ws_acc_pol003_microfiber_name: '精细毛巾套装',
ws_acc_pol003_microfiber_desc: '小尺寸精细打磨超细纤维擦拭布套装',
ws_acc_pol003_finger_guards_name: '指套护具',
ws_acc_pol003_finger_guards_desc: '橡胶指套防护套，防止精细打磨研磨作业中手指磨损',
ws_acc_pol003_case_name: '迷你工具收纳盒',
ws_acc_pol003_case_desc: '紧凑硬壳收纳盒，专为小型抛光机及配件存储设计',

// pol-004 配件
ws_acc_pol004_large_pads_name: '大盘抛光盘套装',
ws_acc_pol004_large_pads_desc: '200mm八寸大盘粗/中/细三件泡沫抛光盘，宽幅覆盖作业',
ws_acc_pol004_compound_name: '大盘研磨膏',
ws_acc_pol004_compound_desc: '500g重度切割抛光膏罐装，宽幅大盘旋转修正专用',
ws_acc_pol004_backing_plate_name: '大尺寸托盘',
ws_acc_pol004_backing_plate_desc: '200mm八寸魔术贴大尺寸托盘，宽幅覆盖作业专用',
ws_acc_pol004_wax_applicators_name: '打蜡涂布盘',
ws_acc_pol004_wax_applicators_desc: '大面积打蜡涂布泡沫盘套装，适用于大面积蜡和镀膜涂布',
ws_acc_pol004_paint_gauge_name: '漆膜厚度计',
ws_acc_pol004_paint_gauge_desc: '汽车漆面涂层厚度数显测量仪，精确测量漆膜厚度',
ws_acc_pol004_cleaning_cloths_name: '大号清洁毛巾',
ws_acc_pol004_cleaning_cloths_desc: '60×40cm大尺寸清洁布，适合大型抛光机研磨膏残留清理',
ws_acc_pol004_gloves_name: '腈纶涂层手套',
ws_acc_pol004_gloves_desc: '腈纶掌面涂层安全手套，大面积抛光重型作业专用',
ws_acc_pol004_toolbox_name: '专业工具箱',
ws_acc_pol004_toolbox_desc: '大容量专业工具箱，专为八寸抛光盘及工具配件存储设计',

// pol-005 配件
ws_acc_pol005_speed_pads_name: '变速配套抛光盘',
ws_acc_pol005_speed_pads_desc: '180mm变速匹配泡沫抛光盘套装，适用于变速抛光机多档操作',
ws_acc_pol005_compound_set_name: '三阶段研磨膏套装',
ws_acc_pol005_compound_set_desc: '一、二、三阶段全套漆面修正研磨膏体系',
ws_acc_pol005_backing_plate_name: '变速托盘',
ws_acc_pol005_backing_plate_desc: '180mm平衡魔术贴变速兼容托盘',
ws_acc_pol005_correction_disc_name: '漆面修正盘',
ws_acc_pol005_correction_disc_desc: '180mm重度切割修正泡沫盘，针对旋痕划痕修正',
ws_acc_pol005_lubricant_name: '机器润滑油',
ws_acc_pol005_lubricant_desc: '抛光机齿轮润滑脂小瓶装，定期维护保养使用',
ws_acc_pol005_microfiber_name: '超细纤维毛巾',
ws_acc_pol005_microfiber_desc: '6件双绒双环超细纤维汽车精细打磨毛巾套装',
ws_acc_pol005_gloves_name: '防振手套',
ws_acc_pol005_gloves_desc: '硅胶防振掌面工作手套，变速抛光机专用',
ws_acc_pol005_manual_name: '速度图表手册',
ws_acc_pol005_manual_desc: '变速抛光机速度档位与材料对应参考图表使用手册',

// pol-006 配件
ws_acc_pol006_combo_pads_name: '组合抛光盘套装',
ws_acc_pol006_combo_pads_desc: '150mm双模式旋转轨道组合泡沫羊毛混合抛光盘套装',
ws_acc_pol006_dual_compound_name: '双模式研磨膏套装',
ws_acc_pol006_dual_compound_desc: '旋转模式和双动作模式两款专用研磨膏套装',
ws_acc_pol006_backing_plate_name: '双模托盘',
ws_acc_pol006_backing_plate_desc: '150mm双模式旋转轨道切换兼容托盘',
ws_acc_pol006_pad_primer_name: '抛光盘预处理剂',
ws_acc_pol006_pad_primer_desc: '泡沫抛光盘预调理喷雾，使用前抛光盘准备',
ws_acc_pol006_cleaning_brushes_name: '抛光盘清洁刷套装',
ws_acc_pol006_cleaning_brushes_desc: '硬软两种刷毛抛光泡沫盘清洁刷套装，维护盘面',
ws_acc_pol006_microfiber_name: '超细纤维毛巾',
ws_acc_pol006_microfiber_desc: '双模式抛光机专业华夫格超细纤维擦拭毛巾套装',
ws_acc_pol006_gloves_name: '机械防振手套',
ws_acc_pol006_gloves_desc: '双模抛光机专用硅胶掌面防振机械手套',
ws_acc_pol006_bag_name: '填充收纳包',
ws_acc_pol006_bag_desc: '带外置口袋的填充尼龙双模抛光机收纳存储包',

// pol-007 配件（无绳）
ws_acc_pol007_battery_name: '锂电池',
ws_acc_pol007_battery_desc: '20V 4Ah无绳抛光机锂电池，充足续航',
ws_acc_pol007_charger_name: '快充充电器',
ws_acc_pol007_charger_desc: '20V锂电池一小时快充充电器',
ws_acc_pol007_foam_pads_name: '泡沫抛光盘套装',
ws_acc_pol007_foam_pads_desc: '125mm三件无绳抛光机专用泡沫盘套装',
ws_acc_pol007_compound_name: '无绳专用研磨膏',
ws_acc_pol007_compound_desc: '250ml轻/中度切割移动作业专用研磨膏',
ws_acc_pol007_backing_plate_name: '托盘',
ws_acc_pol007_backing_plate_desc: '125mm无绳抛光机专用魔术贴托盘',
ws_acc_pol007_microfiber_name: '移动作业毛巾套装',
ws_acc_pol007_microfiber_desc: '无绳移动精细抛光专用紧凑超细纤维毛巾套装',
ws_acc_pol007_holster_name: '腰带挂袋',
ws_acc_pol007_holster_desc: '无绳抛光机作业时腰带携带专用挂袋',
ws_acc_pol007_bag_name: '收纳包',
ws_acc_pol007_bag_desc: '带电池充电器托盘分格的无绳抛光机收纳包',

// pol-008 配件（气动）
ws_acc_pol008_air_connector_name: '气管快接头',
ws_acc_pol008_air_connector_desc: '气动抛光机专用3/8英寸气管快速接头配件',
ws_acc_pol008_air_filter_name: '气动过滤减压阀',
ws_acc_pol008_air_filter_desc: '气动工具专用内联过滤减压储水器',
ws_acc_pol008_foam_pads_name: '气动专用抛光盘',
ws_acc_pol008_foam_pads_desc: '180mm气动抛光机粗/中/细泡沫盘套装',
ws_acc_pol008_compound_name: '气动专用研磨膏',
ws_acc_pol008_compound_desc: '250ml气动抛光机中度切割研磨膏',
ws_acc_pol008_backing_plate_name: '气动托盘',
ws_acc_pol008_backing_plate_desc: '180mm气动抛光机螺纹安装魔术贴托盘',
ws_acc_pol008_microfiber_name: '工业超细纤维布',
ws_acc_pol008_microfiber_desc: '汽车精细打磨工业超细纤维擦拭布大包装',
ws_acc_pol008_ear_protection_name: '耳罩降噪护具',
ws_acc_pol008_ear_protection_desc: '气动工具专用安全听觉保护耳罩',
ws_acc_pol008_manual_name: '气压说明手册',
ws_acc_pol008_manual_desc: '气动抛光机气压参数图表安装操作指南',

// pol-009 配件（湿式）
ws_acc_pol009_diamond_pads_name: '金刚石抛光盘套装',
ws_acc_pol009_diamond_pads_desc: '50~3000目石材大理石湿磨金刚石抛光盘套装',
ws_acc_pol009_stone_polish_name: '石材抛光膏',
ws_acc_pol009_stone_polish_desc: '500ml大理石花岗岩台面翻新镜面光泽石材抛光膏',
ws_acc_pol009_water_nozzle_name: '水冷喷嘴',
ws_acc_pol009_water_nozzle_desc: '湿式石材抛光机水流冷却持续供水喷嘴配件',
ws_acc_pol009_backing_plate_name: '防水托盘',
ws_acc_pol009_backing_plate_desc: '150mm湿式石材抛光机专用防水密封魔术贴托盘',
ws_acc_pol009_shroud_name: '防水挡水罩',
ws_acc_pol009_shroud_desc: '湿式抛光机瓷砖作业专用橡胶防水挡水偏转罩',
ws_acc_pol009_gloves_name: '防水手套',
ws_acc_pol009_gloves_desc: '湿式石材抛光作业专用加厚橡胶防水手套',
ws_acc_pol009_apron_name: '防水工作围裙',
ws_acc_pol009_apron_desc: '湿式石材抛光防水防喷溅橡胶工作围裙',
ws_acc_pol009_manual_name: '操作手册',
ws_acc_pol009_manual_desc: '湿式石材抛光机水压设置操作指南',

// pol-010 配件（智能）
ws_acc_pol010_pad_set_name: '智能托盘套装',
ws_acc_pol010_pad_set_desc: '180mm带目数标签标识的智能LCD抛光机专用泡沫盘套装',
ws_acc_pol010_compound_set_name: '智能研磨膏套装',
ws_acc_pol010_compound_set_desc: '三阶段标签分级智能显示屏抛光机专用研磨膏套装',
ws_acc_pol010_backing_plate_name: '精密平衡托盘',
ws_acc_pol010_backing_plate_desc: '180mm精密平衡智能LCD显示屏抛光机专用托盘',
ws_acc_pol010_microfiber_name: '超细纤维毛巾',
ws_acc_pol010_microfiber_desc: '智能抛光机汽车精细打磨专用高端超细纤维毛巾套装',
ws_acc_pol010_data_cable_name: 'USB数据线',
ws_acc_pol010_data_cable_desc: '智能抛光机LCD固件升级和数据传输USB数据线',
ws_acc_pol010_lcd_shield_name: 'LCD屏幕保护膜',
ws_acc_pol010_lcd_shield_desc: '智能数显抛光机防刮LCD屏幕保护贴膜',
ws_acc_pol010_gloves_name: '触屏兼容手套',
ws_acc_pol010_gloves_desc: '兼容触屏操作智能显示屏抛光机的工作手套',
ws_acc_pol010_case_name: '高端收纳箱',
ws_acc_pol010_case_desc: '智能LCD抛光机专用泡沫内衬高端硬壳收纳箱',

// 砂磨机 san-001 配件
ws_acc_san001_discs_name: '砂碟套装',
ws_acc_san001_discs_desc: '125mm多目数80/120/180/240勾环轨道砂磨机专用砂碟套装',
ws_acc_san001_dust_bag_name: '集尘袋',
ws_acc_san001_dust_bag_desc: '125mm轨道砂磨机专用可重复使用过滤集尘袋',
ws_acc_san001_backing_plate_name: '砂磨托盘',
ws_acc_san001_backing_plate_desc: '125mm轨道砂磨机专用魔术贴软托盘',
ws_acc_san001_sanding_sponge_name: '砂磨海绵块',
ws_acc_san001_sanding_sponge_desc: '柔性多目数轮廓砂磨海绵块，适用于弯曲异形表面木料精细打磨',
ws_acc_san001_cleaning_brush_name: '砂盘清洁刷',
ws_acc_san001_cleaning_brush_desc: '硬毛刷清除魔术贴砂盘表面锯末粉尘，延长砂盘使用寿命',
ws_acc_san001_dust_mask_name: '防尘口罩',
ws_acc_san001_dust_mask_desc: 'N95 FFP2级防尘口罩，木工打磨作业粉尘防护',
ws_acc_san001_goggles_name: '防护目镜',
ws_acc_san001_goggles_desc: '透明防雾镜片防护目镜，打磨粉尘眼睛防护',
ws_acc_san001_case_name: '砂磨机收纳盒',
ws_acc_san001_case_desc: '带砂碟收纳格的砂磨机工具存储盒',

// san-002 配件
ws_acc_san002_discs_name: '150mm砂碟套装',
ws_acc_san002_discs_desc: '150mm六孔勾环砂碟套装，60/80/120/180/240多目数',
ws_acc_san002_dust_bag_name: '大容量集尘袋',
ws_acc_san002_dust_bag_desc: '150mm轨道砂磨机大容量过滤帆布集尘袋',
ws_acc_san002_backing_plate_name: '150mm砂磨托盘',
ws_acc_san002_backing_plate_desc: '150mm六寸轨道砂磨机专用魔术贴托盘',
ws_acc_san002_contour_block_name: '轮廓砂磨块',
ws_acc_san002_contour_block_desc: '柔性弯曲面木工精细打磨人体工学泡沫轮廓砂磨块',
ws_acc_san002_cleaning_brush_name: '砂盘清洁刷',
ws_acc_san002_cleaning_brush_desc: '尼龙刷清除六寸砂磨盘魔术贴面锯末粉尘',
ws_acc_san002_goggles_name: '包裹式防护目镜',
ws_acc_san002_goggles_desc: '包裹式透明镜片防护目镜，木工打磨粉尘保护',
ws_acc_san002_mask_name: '半面防尘呼吸器',
ws_acc_san002_mask_desc: '木工打磨作业专用半面防尘呼吸面罩，细粉尘过滤',
ws_acc_san002_bag_name: '砂磨机工具袋',
ws_acc_san002_bag_desc: '带魔术贴砂碟口袋的轨道砂磨机尼龙携带工具袋',

// san-003 配件
ws_acc_san003_triangle_sheets_name: '三角形砂纸套装',
ws_acc_san003_triangle_sheets_desc: '三角形细节砂磨机专用60/120/240勾环砂纸套装',
ws_acc_san003_corner_pads_name: '角落砂磨垫',
ws_acc_san003_corner_pads_desc: '细节砂磨机专用尖角泡沫软背衬三角形砂磨垫，适用于狭窄角落',
ws_acc_san003_backing_plate_name: '三角形托盘',
ws_acc_san003_backing_plate_desc: '细节角落砂磨机专用灵活魔术贴三角形托盘',
ws_acc_san003_finger_cap_name: '手指砂磨套帽',
ws_acc_san003_finger_cap_desc: '橡胶尖头手指砂磨套帽，手工打磨窄缝隙用',
ws_acc_san003_dust_bag_name: '迷你集尘袋',
ws_acc_san003_dust_bag_desc: '三角形细节砂磨机专用紧凑可重复使用过滤集尘袋',
ws_acc_san003_tweezers_name: '精密镊子套装',
ws_acc_san003_tweezers_desc: '精密镊子工具套装，清除角落打磨残留碎屑',
ws_acc_san003_mask_name: 'FFP2防尘口罩',
ws_acc_san003_mask_desc: '细节打磨专用FFP2 N95防尘口罩，细粉尘过滤保护',
ws_acc_san003_manual_name: '使用说明手册',
ws_acc_san003_manual_desc: '细节砂磨机操作小册，含角落打磨技巧指南',

// san-004 配件
ws_acc_san004_belts_name: '砂带套装',
ws_acc_san004_belts_desc: '200mm宽砂带套装，40/60/80/120多目数砂带机专用',
ws_acc_san004_tracking_tool_name: '跑带调节工具',
ws_acc_san004_tracking_tool_desc: '宽幅砂带机专用跑带对齐调节扳手',
ws_acc_san004_belt_clips_name: '砂带夹扣',
ws_acc_san004_belt_clips_desc: '宽幅砂带机砂带固定夹扣备件套装',
ws_acc_san004_guide_frame_name: '导向靠山',
ws_acc_san004_guide_frame_desc: '宽幅砂带机直线切割控制导向靠山框架',
ws_acc_san004_cleaning_stick_name: '砂带清洁橡皮',
ws_acc_san004_cleaning_stick_desc: '磨料砂带清洁橡皮擦，去除堵塞锯末粉末',
ws_acc_san004_dust_bag_name: '大容量集尘袋',
ws_acc_san004_dust_bag_desc: '砂带机专用大容量高效过滤集尘袋',
ws_acc_san004_gloves_name: '防切割手套',
ws_acc_san004_gloves_desc: '砂带机操作专用防切割防磨损工作手套',
ws_acc_san004_manual_name: '砂带更换指南',
ws_acc_san004_manual_desc: '砂带机用户手册，含砂带更换和安全操作说明',

// san-005 配件
ws_acc_san005_grit_discs_name: '多目数砂碟套装',
ws_acc_san005_grit_discs_desc: '125mm 60~600目全系列砂碟套装，变速砂磨机专用',
ws_acc_san005_speed_pads_name: '变速配套砂盘',
ws_acc_san005_speed_pads_desc: '125mm变速砂磨机配套不同密度等级泡沫砂盘',
ws_acc_san005_backing_plate_name: '可换软托盘',
ws_acc_san005_backing_plate_desc: '125mm变速砂磨机专用可换软界面魔术贴托盘',
ws_acc_san005_contour_kit_name: '轮廓打磨套件',
ws_acc_san005_contour_kit_desc: '变速打磨弯曲异形表面各种形状泡沫轮廓砂磨套件',
ws_acc_san005_cleaning_brush_name: '砂盘清洁刷',
ws_acc_san005_cleaning_brush_desc: '变速砂磨机专用维护砂盘魔术贴清洁刷',
ws_acc_san005_mask_name: '防尘呼吸面罩',
ws_acc_san005_mask_desc: '变速木工打磨过滤呼吸防尘面罩',
ws_acc_san005_pouch_name: '砂碟收纳袋',
ws_acc_san005_pouch_desc: '砂碟配件有序整理卷轴式收纳袋',
ws_acc_san005_manual_name: '速度材料对照表',
ws_acc_san005_manual_desc: '变速砂磨机速度档位与材料对应参考表卡',

// san-006 配件（干湿两用）
ws_acc_san006_wet_discs_name: '干湿两用砂碟',
ws_acc_san006_wet_discs_desc: '150mm碳化硅干湿两用砂碟套装，水磨专用',
ws_acc_san006_drain_tube_name: '排水软管',
ws_acc_san006_drain_tube_desc: '干湿两用砂磨机专用排水出水连接软管',
ws_acc_san006_sealing_ring_name: '密封圈套装',
ws_acc_san006_sealing_ring_desc: '干湿两用砂磨机专用防水密封圈垫片套装',
ws_acc_san006_backing_plate_name: '防水托盘',
ws_acc_san006_backing_plate_desc: '150mm干湿两用砂磨机专用防锈防水托盘',
ws_acc_san006_squeegee_name: '刮水板',
ws_acc_san006_squeegee_desc: '湿式打磨残留清除表面清洁橡胶刮水板',
ws_acc_san006_gloves_name: '防水手套',
ws_acc_san006_gloves_desc: '湿式打磨海洋漆面专用腈纶防水手套',
ws_acc_san006_apron_name: '防水工作围裙',
ws_acc_san006_apron_desc: '湿式打磨海洋漆面防水防喷溅作业工作围裙',
ws_acc_san006_manual_name: '干湿用法手册',
ws_acc_san006_manual_desc: '干湿两用砂磨机防水操作指南和安全注意事项',

// san-007 配件（无绳）
ws_acc_san007_battery_name: '锂电池',
ws_acc_san007_battery_desc: '20V 3Ah无绳砂磨机锂电池，持续稳定供电',
ws_acc_san007_charger_name: '快充充电器',
ws_acc_san007_charger_desc: '20V锂电池一小时快充充电器，高效补电',
ws_acc_san007_discs_name: '无绳砂碟包',
ws_acc_san007_discs_desc: '125mm无绳砂磨机专用40件多目数勾环砂碟包',
ws_acc_san007_dust_bag_name: '集尘袋',
ws_acc_san007_dust_bag_desc: '无绳砂磨机专用紧凑型过滤集尘袋备件',
ws_acc_san007_backing_plate_name: '砂磨托盘',
ws_acc_san007_backing_plate_desc: '125mm无绳砂磨机专用魔术贴托盘备件',
ws_acc_san007_cleaning_brush_name: '砂盘清洁刷',
ws_acc_san007_cleaning_brush_desc: '无绳砂磨机专用魔术贴砂盘清洁维护刷',
ws_acc_san007_bag_name: '无绳收纳包',
ws_acc_san007_bag_desc: '带电池充电器砂碟口袋的无绳砂磨机专用收纳包',
ws_acc_san007_manual_name: '电池护理手册',
ws_acc_san007_manual_desc: '无绳砂磨机电池保养和操作使用说明',

// san-008 配件（气动）
ws_acc_san008_air_fitting_name: '气管快接头',
ws_acc_san008_air_fitting_desc: '气动掌形砂磨机专用1/4英寸NPT气管快速接头',
ws_acc_san008_inline_oiler_name: '内联注油器',
ws_acc_san008_inline_oiler_desc: '气动砂磨机维护专用内联供油润滑器',
ws_acc_san008_sheets_name: '掌形砂纸套装',
ws_acc_san008_sheets_desc: '100mm气动掌形砂磨机专用80/120/180/240砂纸套装',
ws_acc_san008_dust_bag_name: '集尘袋',
ws_acc_san008_dust_bag_desc: '气动掌形砂磨机专用紧凑过滤可重复使用集尘袋',
ws_acc_san008_rubber_pad_name: '橡胶砂磨垫',
ws_acc_san008_rubber_pad_desc: '100mm气动掌形砂磨机专用魔术贴面橡胶砂磨垫',
ws_acc_san008_ear_plugs_name: '防噪耳塞',
ws_acc_san008_ear_plugs_desc: '气动工具降噪泡沫耳塞，听觉防护',
ws_acc_san008_gloves_name: '防振手套',
ws_acc_san008_gloves_desc: '气动工具掌形砂磨机专用防振硅胶掌面手套',
ws_acc_san008_manual_name: '气压表手册',
ws_acc_san008_manual_desc: '气动掌形砂磨机气压参数表安装操作指南',

// san-009 配件（墙面天花板）
ws_acc_san009_extension_pole_name: '伸缩延长杆',
ws_acc_san009_extension_pole_desc: '1.5~3米天花板墙面砂磨机伸缩延长杆连接件',
ws_acc_san009_ceiling_discs_name: '天花板专用砂碟',
ws_acc_san009_ceiling_discs_desc: '150mm天花板墙面砂磨机专用60/80/120/180砂碟套装',
ws_acc_san009_flex_head_name: '柔性铰接头',
ws_acc_san009_flex_head_desc: '长杆砂磨机天花板角度调节柔性铰接头',
ws_acc_san009_dust_hose_name: '集尘软管延伸',
ws_acc_san009_dust_hose_desc: '长杆天花板砂磨机集尘连接吸尘器延伸软管',
ws_acc_san009_goggles_name: '头顶作业护目镜',
ws_acc_san009_goggles_desc: '密封型防护目镜，头顶打磨粉尘下落保护',
ws_acc_san009_neck_strap_name: '颈部支撑带',
ws_acc_san009_neck_strap_desc: '长杆砂磨机重量支撑可调节颈部肩部背带',
ws_acc_san009_gloves_name: '头顶作业手套',
ws_acc_san009_gloves_desc: '头顶天花板打磨长袖口手腕保护工作手套',
ws_acc_san009_manual_name: '延长杆安装手册',
ws_acc_san009_manual_desc: '长杆天花板砂磨机延长杆安装和头顶作业安全指南',

// san-010 配件（静音）
ws_acc_san010_low_vib_discs_name: '低振砂碟套装',
ws_acc_san010_low_vib_discs_desc: '125mm静音砂磨机专用平衡低振砂碟，降低噪声',
ws_acc_san010_acoustic_pad_name: '隔音界面垫',
ws_acc_san010_acoustic_pad_desc: '静音砂磨机专用减振隔音层泡沫界面垫',
ws_acc_san010_quiet_bag_name: '静音集尘袋',
ws_acc_san010_quiet_bag_desc: '静音砂磨机专用密封过滤低气流噪音集尘袋',
ws_acc_san010_vib_gloves_name: '防振凝胶手套',
ws_acc_san010_vib_gloves_desc: '静音砂磨机专用硅胶防振增强舒适度手套',
ws_acc_san010_backing_plate_name: '软界面托盘',
ws_acc_san010_backing_plate_desc: '125mm静音砂磨机专用额外减振软界面托盘',
ws_acc_san010_cleaning_brush_name: '砂盘清洁刷',
ws_acc_san010_cleaning_brush_desc: '静音砂磨机专用魔术贴砂碟清洁维护刷',
ws_acc_san010_case_name: '减震收纳盒',
ws_acc_san010_case_desc: '静音低噪砂磨机专用泡沫填充减震保护收纳盒',
ws_acc_san010_manual_name: '噪音规格说明书',
ws_acc_san010_manual_desc: '静音砂磨机噪音规格指南和静音操作使用说明',

// 热熔胶枪 glue-001 配件
ws_acc_glue001_sticks_name: '热熔胶棒套装',
ws_acc_glue001_sticks_desc: '11mm标准热熔胶棒50支装，透明通用型强力粘接',
ws_acc_glue001_nozzle_name: '替换喷嘴',
ws_acc_glue001_nozzle_desc: '标准热熔胶枪11mm螺纹替换喷嘴',
ws_acc_glue001_cleaner_name: '喷嘴清洁工具',
ws_acc_glue001_cleaner_desc: '热熔胶枪喷嘴疏通清洁针套装，清除胶液残留堵塞',
ws_acc_glue001_mat_name: '硅胶防热台垫',
ws_acc_glue001_mat_desc: '热熔胶枪作业隔热硅胶防热台面保护垫',
ws_acc_glue001_stand_name: '胶枪休息支架',
ws_acc_glue001_stand_desc: '热熔胶枪金属支架，闲置时竖直放置防止台面灼伤',
ws_acc_glue001_finger_protectors_name: '硅胶指套',
ws_acc_glue001_finger_protectors_desc: '热熔胶枪作业防烫硅胶指套护帽套装',
ws_acc_glue001_gloves_name: '防热手套',
ws_acc_glue001_gloves_desc: '热熔胶枪手工艺作业耐热防护手套',
ws_acc_glue001_bag_name: '收纳袋',
ws_acc_glue001_bag_desc: '带胶棒口袋的热熔胶枪专用尼龙携带收纳袋',

// glue-002 配件（工业高温）
ws_acc_glue002_industrial_sticks_name: '工业强力胶棒',
ws_acc_glue002_industrial_sticks_desc: '11mm工业强力热熔胶棒30支装，高粘结力重型专用',
ws_acc_glue002_wide_nozzle_name: '宽平喷嘴',
ws_acc_glue002_wide_nozzle_desc: '11mm工业高温胶枪宽幅宽平涂布大面积专用喷嘴',
ws_acc_glue002_funnel_nozzle_name: '漏斗喷嘴',
ws_acc_glue002_funnel_nozzle_desc: '工业高温胶枪宽幅填缝应用专用漏斗形喷嘴',
ws_acc_glue002_cleaning_kit_name: '清洁套件',
ws_acc_glue002_cleaning_kit_desc: '工业高温胶枪专用刷子针头溶剂清洁套件',
ws_acc_glue002_mat_name: '大尺寸硅胶台垫',
ws_acc_glue002_mat_desc: '工业高温胶枪作业专用大尺寸隔热防粘硅胶台垫',
ws_acc_glue002_heat_gloves_name: '200°C耐热手套',
ws_acc_glue002_heat_gloves_desc: '工业高温胶枪200°C额定耐热工作手套',
ws_acc_glue002_stand_name: '重型支架',
ws_acc_glue002_stand_desc: '工业高温胶枪专用重型金属支架，稳固支撑放置',
ws_acc_glue002_case_name: '工具箱',
ws_acc_glue002_case_desc: '工业高温胶枪喷嘴胶棒配件专用硬壳工具箱',

// glue-003 配件（迷你）
ws_acc_glue003_mini_sticks_name: '7mm迷你胶棒',
ws_acc_glue003_mini_sticks_desc: '7mm迷你热熔胶棒100支装，透明细型手工艺品专用',
ws_acc_glue003_fine_nozzle_name: '细头精密喷嘴',
ws_acc_glue003_fine_nozzle_desc: '7mm迷你热熔胶枪细头精密少量涂布专用喷嘴',
ws_acc_glue003_wiper_name: '喷嘴擦拭垫',
ws_acc_glue003_wiper_desc: '迷你热熔胶枪防滴漏喷嘴清洁硅胶擦拭垫',
ws_acc_glue003_stand_name: '迷你支架',
ws_acc_glue003_stand_desc: '迷你热熔胶枪专用小型支撑休息支架',
ws_acc_glue003_tweezers_name: '工艺镊子',
ws_acc_glue003_tweezers_desc: '迷你胶枪手工艺品精细作业定位小零件镊子工具',
ws_acc_glue003_craft_mat_name: '手工艺台垫',
ws_acc_glue003_craft_mat_desc: '迷你热熔胶枪手工项目作业小尺寸硅胶台垫',
ws_acc_glue003_finger_guard_name: '指套护具',
ws_acc_glue003_finger_guard_desc: '迷你工艺胶枪细节作业专用防烫指套护具',
ws_acc_glue003_manual_name: '使用说明手册',
ws_acc_glue003_manual_desc: '迷你热熔胶枪操作指南和手工艺品制作创意说明',

// glue-004 配件（双温）
ws_acc_glue004_color_sticks_name: '色码胶棒套装',
ws_acc_glue004_color_sticks_desc: '双温胶枪专用高温低温色标区分11mm热熔胶棒套装',
ws_acc_glue004_dual_nozzle_name: '双温喷嘴',
ws_acc_glue004_dual_nozzle_desc: '双模式双温热熔胶枪高低温兼容喷嘴',
ws_acc_glue004_adapter_name: '喷嘴适配器套装',
ws_acc_glue004_adapter_desc: '双温胶枪多种喷嘴尖端配置专用适配器套装',
ws_acc_glue004_temp_chart_name: '温度材料对照表',
ws_acc_glue004_temp_chart_desc: '双温胶枪温度与材料对应关系参考卡',
ws_acc_glue004_mat_name: '双区域台垫',
ws_acc_glue004_mat_desc: '双温胶枪作业双区域隔热硅胶工作台垫',
ws_acc_glue004_gloves_name: '硅胶工作手套',
ws_acc_glue004_gloves_desc: '双温胶枪作业专用防烫硅胶工作手套',
ws_acc_glue004_stand_name: '支架',
ws_acc_glue004_stand_desc: '双温热熔胶枪专用金属支撑支架',
ws_acc_glue004_pouch_name: '配件收纳袋',
ws_acc_glue004_pouch_desc: '双温胶枪喷嘴胶棒配件专用收纳袋',

// glue-005 配件（无绳）
ws_acc_glue005_battery_name: '锂电池',
ws_acc_glue005_battery_desc: '20V 2Ah无绳热熔胶枪可充电锂电池',
ws_acc_glue005_charger_name: '充电器',
ws_acc_glue005_charger_desc: '20V锂电池无绳胶枪专用快充充电底座',
ws_acc_glue005_sticks_name: '热熔胶棒',
ws_acc_glue005_sticks_desc: '11mm热熔胶棒30支装，无绳20V胶枪移动作业专用',
ws_acc_glue005_nozzle_name: '替换喷嘴',
ws_acc_glue005_nozzle_desc: '无绳热熔胶枪11mm螺纹替换喷嘴备件',
ws_acc_glue005_mat_name: '便携硅胶台垫',
ws_acc_glue005_mat_desc: '无绳胶枪户外工程作业便携隔热硅胶台垫',
ws_acc_glue005_holster_name: '腰带挂袋',
ws_acc_glue005_holster_desc: '无绳热熔胶枪作业时腰带携带专用挂袋',
ws_acc_glue005_finger_guard_name: '指套护具',
ws_acc_glue005_finger_guard_desc: '无绳胶枪移动作业防烫硅胶指套护具',
ws_acc_glue005_bag_name: '收纳包',
ws_acc_glue005_bag_desc: '带电池充电器胶棒分格无绳胶枪收纳包',

// glue-006 配件（精密）
ws_acc_glue006_precision_sticks_name: '精密细胶棒',
ws_acc_glue006_precision_sticks_desc: '11mm精密细型热熔胶棒40支装，细节手工艺作业专用',
ws_acc_glue006_nozzle_set_name: '精密喷嘴套装',
ws_acc_glue006_nozzle_set_desc: '精密热熔胶枪5件不同直径精密喷嘴套装',
ws_acc_glue006_cleaner_pin_name: '喷嘴清洁针',
ws_acc_glue006_cleaner_pin_desc: '细头热熔胶枪精密疏通专用喷嘴清洁针工具',
ws_acc_glue006_work_mat_name: '带网格台垫',
ws_acc_glue006_work_mat_desc: '带刻度网格测量的精密胶枪手工艺作业专用台垫',
ws_acc_glue006_stand_name: '精密胶枪支架',
ws_acc_glue006_stand_desc: '精密热熔胶枪专用倾斜休息支架，细头喷嘴作业专用',
ws_acc_glue006_magnifier_name: '放大镜支架',
ws_acc_glue006_magnifier_desc: '精密手工艺细节胶枪作业专用免手持放大镜支架',
ws_acc_glue006_finger_guard_name: '指套护具',
ws_acc_glue006_finger_guard_desc: '精密工艺胶枪细节作业专用防烫指套护具',
ws_acc_glue006_case_name: '精密收纳盒',
ws_acc_glue006_case_desc: '精密胶枪细头喷嘴配件存储专用泡沫内衬收纳盒',

// glue-007 配件（工业大型）
ws_acc_glue007_cartridges_name: '43mm胶料筒',
ws_acc_glue007_cartridges_desc: '43mm工业热熔胶料筒10支装，高粘度重型专用',
ws_acc_glue007_wide_nozzle_name: '宽边喷嘴',
ws_acc_glue007_wide_nozzle_desc: '43mm工业胶枪宽幅覆盖平宽喷嘴',
ws_acc_glue007_ext_nozzle_name: '延长喷嘴',
ws_acc_glue007_ext_nozzle_desc: '工业胶枪43mm深部凹陷处涂胶专用延长喷嘴',
ws_acc_glue007_cleaning_rod_name: '桶身清洁棒',
ws_acc_glue007_cleaning_rod_desc: '43mm工业胶枪残留胶液清除专用金属清洁棒',
ws_acc_glue007_mat_name: '重型硅胶台垫',
ws_acc_glue007_mat_desc: '工业胶枪高温作业专用重型隔热硅胶工作台垫',
ws_acc_glue007_heat_gloves_name: '300°C工业手套',
ws_acc_glue007_heat_gloves_desc: '大型热熔胶枪操作专用300°C额定工业耐热手套',
ws_acc_glue007_stand_name: '重型支架',
ws_acc_glue007_stand_desc: '43mm工业热熔胶枪专用重型金属稳固支撑支架',
ws_acc_glue007_tool_bag_name: '工业工具袋',
ws_acc_glue007_tool_bag_desc: '大型热熔胶枪43mm胶料筒喷嘴配件专用工具袋',

// glue-008 配件（LED智能）
ws_acc_glue008_sticks_name: '热熔胶棒',
ws_acc_glue008_sticks_desc: '11mm热熔胶棒50支装，LED指示智能胶枪专用透明型',
ws_acc_glue008_led_module_name: 'LED指示模块',
ws_acc_glue008_led_module_desc: '智能热熔胶枪LED就绪指示灯电路板替换模块',
ws_acc_glue008_nozzle_set_name: '喷嘴套装',
ws_acc_glue008_nozzle_set_desc: 'LED指示热熔胶枪标准/细头/宽头3件喷嘴套装',
ws_acc_glue008_gauge_name: '校准工具',
ws_acc_glue008_gauge_name_desc: '智能胶枪LED就绪指示灯校准检测工具',
ws_acc_glue008_gauge_desc: '智能胶枪LED就绪指示灯校准检测工具',
ws_acc_glue008_mat_name: '硅胶台垫',
ws_acc_glue008_mat_desc: '智能LED胶枪作业专用隔热硅胶台面保护垫',
ws_acc_glue008_cleaning_brush_name: '清洁刷套装',
ws_acc_glue008_cleaning_brush_desc: '智能胶枪喷嘴桶身维护清洁刷套装',
ws_acc_glue008_stand_name: '智能支架',
ws_acc_glue008_stand_desc: 'LED指示热熔胶枪专用金属稳固支撑支架',
ws_acc_glue008_manual_name: '使用说明书',
ws_acc_glue008_manual_desc: '智能LED胶枪指示灯状态说明和操作使用手册',

// glue-009 配件（双嘴）
ws_acc_glue009_nozzle_kit_name: '可换嘴套件',
ws_acc_glue009_nozzle_kit_desc: '双嘴热熔胶枪8件不同嘴型可换喷嘴套件',
ws_acc_glue009_sticks_name: '多彩胶棒套装',
ws_acc_glue009_sticks_desc: '双嘴热熔胶枪手工艺品多彩11mm热熔胶棒套装',
ws_acc_glue009_switch_tool_name: '换嘴工具',
ws_acc_glue009_switch_tool_desc: '双嘴胶枪专用喷嘴安全拆卸安装扳手工具',
ws_acc_glue009_caps_name: '密封堵头',
ws_acc_glue009_caps_desc: '双嘴胶枪闲置喷嘴口密封存储塞帽套装',
ws_acc_glue009_mat_name: '双区台垫',
ws_acc_glue009_mat_desc: '双嘴胶枪项目作业双区域隔热硅胶工作台垫',
ws_acc_glue009_anti_drip_name: '防滴漏护具',
ws_acc_glue009_anti_drip_desc: '双嘴热熔胶枪防止胶液滴漏专用防滴漏护具',
ws_acc_glue009_rack_name: '喷嘴收纳架',
ws_acc_glue009_rack_desc: '双嘴热熔胶枪8槽喷嘴有序收纳壁挂式收纳架',
ws_acc_glue009_manual_name: '使用说明书',
ws_acc_glue009_manual_desc: '双嘴热熔胶枪喷嘴图表和应用说明使用手册',

// glue-010 配件（长嘴）
ws_acc_glue010_sticks_name: '热熔胶棒',
ws_acc_glue010_sticks_desc: '11mm热熔胶棒40支装，长嘴胶枪通用型',
ws_acc_glue010_ext_nozzle_tips_name: '延伸喷嘴头套装',
ws_acc_glue010_ext_nozzle_tips_desc: '长嘴胶枪不同长度延伸喷嘴头套装',
ws_acc_glue010_adapter_name: '喷嘴延伸适配器',
ws_acc_glue010_adapter_desc: '长伸手热熔胶枪额外增加长度专用喷嘴延伸适配器',
ws_acc_glue010_deep_reach_name: '深入弯头涂胶器',
ws_acc_glue010_deep_reach_desc: '热熔胶枪深部凹陷狭窄空间涂胶专用弯曲柔性深入涂胶器',
ws_acc_glue010_mat_name: '硅胶台垫',
ws_acc_glue010_mat_desc: '延长喷嘴胶枪项目作业专用隔热硅胶台垫',
ws_acc_glue010_sleeve_name: '隔热硅胶套管',
ws_acc_glue010_sleeve_name_desc: '长嘴热熔胶枪意外接触保护专用耐热硅胶套管',
ws_acc_glue010_sleeve_desc: '长嘴热熔胶枪意外接触保护专用耐热硅胶套管',
ws_acc_glue010_stand_name: '加高支架',
ws_acc_glue010_stand_desc: '长嘴热熔胶枪专用高支脚加高支撑支架',
  ws_acc_glue010_case_name: '长型收纳盒',
  ws_acc_glue010_case_desc: '容纳长喷嘴全长工具的长型热熔胶枪专用收纳存储盒',
};

export default workshopFeaturesZh;
